<div class="nav_container" *ngIf="logged === 'true' && profil === 4">
  <div class="mb-4">
    <ul>
      <li class="mb-2">
        <a [routerLink]="['users/list-mentors']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
          routerLinkActive="active-link">
          <svg style="margin-left: -5px; width: 22px; height: 22px" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <!-- Icône de documents/candidatures (contour) -->
            <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z" />
            <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              d="M14 2v6h6M8 15h8M8 11h8M8 7h5" />
          </svg>
          <span style="margin-left: 10px">Gestion Candidatures</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/groupe']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
          <span class="ml-3">Gestion Groupes</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/gestionmentor']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
          <span class="ml-3">Gestion Mentors</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/paiement']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
            <line x1="3" y1="11" x2="21" y2="11" />
            <line x1="7" y1="15" x2="9" y2="15" />
            <circle cx="18" cy="7" r="3" />
            <path d="M16.5 7.5l1 1 2-2" />
          </svg>
          <span class="ml-3">Gestion Paiements</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/lesemploisdutemps']" class="nav_item" routerLinkActive="active-link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="#E5E8EC" stroke="black" stroke-width="6"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          <span class="ml-3">Les emplois du temps</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['users/profil']" class="nav_item" routerLinkActive="active-link">
          <svg class="text-greyLighter" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 14 18">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z" />
          </svg>
          <span class="ml-3">Mon Profil</span>
        </a>
      </li>
    </ul>
  </div>
</div>